const EventSeverity = {
	ERROR: 'Error',
	WARNING: 'Warning',
	INFO: 'Info',
	OK: 'OK'
};

export default EventSeverity;
